import { render, staticRenderFns } from "./anKangPerson.vue?vue&type=template&id=300cfbe8&scoped=true&"
import script from "./anKangPerson.vue?vue&type=script&lang=js&"
export * from "./anKangPerson.vue?vue&type=script&lang=js&"
import style0 from "./anKangPerson.vue?vue&type=style&index=0&lang=css&"
import style1 from "./anKangPerson.vue?vue&type=style&index=1&id=300cfbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300cfbe8",
  null
  
)

export default component.exports